import React from 'react';
import { Box, Image, Proportion } from '@wix/design-system';
import s from '../../TemplateCard.module.scss';
const AnimatedPreviewOverlayContent = _ref => {
  let {
    animatedPreview
  } = _ref;
  return /*#__PURE__*/React.createElement(Proportion, {
    aspectRatio: 1
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    verticalAlign: "middle",
    display: "flex",
    align: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    fit: "cover",
    width: "100%",
    showBorder: true,
    className: `${s.gif} ${s.gifVisible}`,
    borderRadius: "4px",
    transparent: true,
    alt: animatedPreview?.description || 'template image',
    src: animatedPreview?.url
  })));
};
export default AnimatedPreviewOverlayContent;
//# sourceMappingURL=AnimatedPreviewOverlayContent.js.map